import { Languages, Layers, MapPin, ShieldCheck } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { C } from "@/data/content";
import Reveal, { SectionHeader } from "@/components/Reveal";

const ICONS = { mappin: MapPin, layers: Layers, shield: ShieldCheck, languages: Languages };

export default function WhyUs() {
    const { L } = useLanguage();

    return (
        <section id="why-us" className="py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6">
                <SectionHeader
                    eyebrow={L(C.whyus.eyebrow)}
                    title={L(C.whyus.title)}
                    align="center"
                />

                <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
                    {C.whyus.items.map((item, i) => {
                        const Icon = ICONS[item.icon];
                        return (
                            <Reveal key={i} delay={0.08 * i} className="h-full">
                                <article
                                    data-testid={`why-us-card-${i + 1}`}
                                    className="group h-full rounded-2xl border border-gold-line bg-ink-3/60 p-7 transition-all duration-300 hover:-translate-y-1 hover:border-gold-line-strong hover:shadow-[0_0_25px_rgba(212,175,55,0.12)]"
                                >
                                    <span className="grid size-12 place-items-center rounded-full border border-gold-line-strong text-brass transition-colors group-hover:bg-brass group-hover:text-ink">
                                        <Icon className="size-5" />
                                    </span>
                                    <h3 className="font-display mt-6 text-lg font-bold text-txt-1">
                                        {L(item.title)}
                                    </h3>
                                    <p className="mt-3 text-sm leading-relaxed text-txt-2">
                                        {L(item.desc)}
                                    </p>
                                </article>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
